import { useCallback, useState } from 'react';

import useListActions from '@/hooks/useList/useListActions';

import { FilterListActionsProps, FilterOperators, FilterOption } from '../../types';

export default function useFilterListActions({
  selectedItems,
  keyExtractor,
  showActionButtons,
  onChange,
  operators,
  selectedOperator,
}: FilterListActionsProps) {
  const [currSelectedOperator, setSelectedOperator] = useState<FilterOperators | undefined>(
    selectedOperator || operators?.[0],
  );

  const onFilterChange = useCallback(
    (val: FilterOption[]) => {
      onChange?.(val, currSelectedOperator);
    },
    [onChange, currSelectedOperator],
  );

  const [
    selectedFilters,
    { toggle: toggleOption, addMultiple, removeMultiple, removeAll, addSingle },
  ] = useListActions({
    selectedItems,
    keyExtractor,
    updateOnAction: !showActionButtons,
    onChange: onFilterChange,
  });

  return {
    state: {
      selectedFilters,
      selectedOperator: currSelectedOperator,
    },
    methods: {
      toggleOption,
      addMultiple,
      removeMultiple,
      removeAll,
      addSingle,
      setSelectedOperator,
    },
  };
}
